<template>
  <div class="p-table__content">
    <table>
      <thead>
        <tr>
          <th>
            {{ $t('pages.CompaniesTestimonials.file.createdAt') }}
            <span class="p-table__content__sort" :class="`is-${ sortOrder }`" @click="$emit('sort')" />
          </th>
          <th>
            {{ $t('pages.CompaniesTestimonials.file.originalFilename') }}
          </th>
          <th>
            {{ $t('pages.CompaniesTestimonials.file.importStatus') }}
          </th>
          <th>
            {{ $t('pages.CompaniesTestimonials.file.userName') }}
          </th>
          <th>
            {{ $t('pages.CompaniesTestimonials.file.operation') }}
          </th>
        </tr>
        <tr class="p-table__content__space">
          <td colspan="5" />
        </tr>
      </thead>
      <tbody>
        <tr v-for="(data, i) in datas" :key="`file_${i}`" :class="{ 'progress': ['progress', 'pending'].includes(data.importStatus) }">
          <td>
            {{ basicDateTimeFormat(data.createdAt) }}
          </td>
          <td>
            {{ data.originalFilename }}
          </td>
          <td class="importStatus" @click="clickDisplayErrorModal(data)">
            <span :class="`importStatus__circle--${ data.importStatus }`" />
            <span :class="{ 'error': data.importStatus === 'error' }">
              {{ $t(`pages.CompaniesTestimonials.file.label.${data.importStatus}`) }}
            </span>
          </td>
          <td>
            {{ data.userLastName + data.userFirstName }}
          </td>
          <td>
            <div v-show="['error', 'complete'].includes(data.importStatus)" class="operation">
              <div class="operation__download" @click="$emit('download-file', data)">
                {{ $t('pages.CompaniesTestimonials.file.download') }}
              </div>
              <div @click="$emit('delete-file', data)">
                {{ $t('pages.CompaniesTestimonials.file.deleteFile', { value: $t(`pages.CompaniesTestimonials.file.label.deleteFile.${data.importStatus}`) }) }}
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <ErrorModal
      :show-modal="showErrorModal"
      :errors="errors"
      @close-modal="closeErrorModal"
    />
  </div>
</template>

<script>
import moment from 'moment'
import ErrorModal from './ErrorModal'

export default {
  name: 'CompaniesTestimonialsFilesTable',
  components: {
    ErrorModal,
  },
  props: {
    datas: Array,
    sortOrder: String,
  },
  emits: ['sort', 'download-file', 'delete-file'],
  data() {
    return {
      showErrorModal: false,
      errors: null,
    }
  },
  methods: {
    basicDateTimeFormat: function (date) {
      return date ? moment(date).format(this.$t('format.datetime.default')) : ''
    },
    closeErrorModal() {
      this.showErrorModal = false
    },
    clickDisplayErrorModal(data) {
      if (!data) return
      if (data.importStatus !== 'error') return
      this.errors = data.importErrors
      this.showErrorModal = true
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../stylesheets/biz_spa/foundation/_var.scss';

.error {
  color: #E9446A;
  text-decoration: underline;
  cursor: pointer;
}

.progress {
  background: #f8f9fa;
}
.importStatus {
  align-items: center;
  %__circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 5px;
    border-radius: 100%;
  }
  &__circle {
    &--complete {
      @extend %__circle;
      background: $complete-color;
    }

    &--error {
      @extend %__circle;
      background: #E9446A;
    }

    &--progress {
      @extend %__circle;
      background: #D2D5DB;
    }

    &--pending {
      @extend %__circle;
      background: #D2D5DB;
    }
  }
}

.operation {
  text-decoration: underline;
  cursor: pointer;
  display: flex;
  font-size: 12px;
  &__download {
    margin-right: 10px;
  }
}

.p-table__content {
  tbody {
    td {
      background: unset;
    }
  }
}
</style>
